export const ARROW_DOWN = "/images/arrowDown.svg";
export const ARROW_UP = "/images/arrowUp.svg";
